import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { BarcodeDto, BarcodeCreateDto, BarcodeUpdateDto } from "src/dtos/barcode/barcodeDto";
import { getData, postData, patchData, deleteData } from "src/utils/axios/serverHelper";

const barcodeUrl = `${config.apiUrl}/PDA1110_R01`;

/**
 * 바코드 목록 조회
 * @param searchText 검색어
 * @param listLength 리스트 길이
 * @param refetchListLength 재조회 리스트 길이
 */
export const getBarcodeList = async (
  searchText?: string,
  listLength?: number,
  refetchListLength?: number
) => {
  return await getData<ResponseDto<BarcodeDto[]>>(barcodeUrl, {
    params: {
      searchText,
      listLength,
      refetchListLength
    }
  });
};

/**
 * 바코드 상세 조회
 * @param barcode 바코드
 */
export const getBarcodeDetail = async (barcode: string) => {
  const url = `${barcodeUrl}/one/${barcode}`;
  return await getData<ResponseDto<BarcodeDto>>(url);
};

/**
 * 품목코드로 바코드 목록 조회
 * @param itemCd 품목코드
 */
export const getBarcodeListByItemCd = async (itemCd: string) => {
  const url = `${barcodeUrl}/item/${itemCd}`;
  return await getData<ResponseDto<BarcodeDto[]>>(url);
};

/**
 * 바코드 등록
 * @param data 바코드 등록 데이터
 */
export const createBarcode = async (data: BarcodeCreateDto) => {
  return await postData<BarcodeCreateDto, ResponseDto<BarcodeDto>>(barcodeUrl, data);
};

/**
 * 바코드 일괄 등록
 * @param dataList 바코드 등록 데이터 배열
 */
export const createBarcodeBatch = async (dataList: BarcodeCreateDto[]) => {
  const url = `${barcodeUrl}/batch`;
  return await postData<BarcodeCreateDto[], ResponseDto<BarcodeDto[]>>(url, dataList);
};

/**
 * 바코드 수정
 * @param data 바코드 수정 데이터
 */
export const updateBarcode = async (data: BarcodeUpdateDto) => {
  return await patchData<BarcodeUpdateDto, ResponseDto<BarcodeDto>>(barcodeUrl, data);
};

/**
 * 바코드 삭제
 * @param barcode 삭제할 바코드
 */
export const deleteBarcode = async (barcode: string) => {
  const url = `${barcodeUrl}/${barcode}`;
  return await deleteData<ResponseDto<null>>(url);
};

/**
 * 바코드 일괄 삭제
 * @param barcodeList 삭제할 바코드 배열
 */
export const deleteBarcodeBatch = async (barcodeList: string[]) => {
  const url = `${barcodeUrl}/batch`;
  return await deleteData<ResponseDto<null>>(url, { data: barcodeList });
};
